import { render, staticRenderFns } from "./DeptAdd.vue?vue&type=template&id=3187a7c1&scoped=true&"
import script from "./DeptAdd.vue?vue&type=script&lang=js&"
export * from "./DeptAdd.vue?vue&type=script&lang=js&"
import style0 from "./DeptAdd.vue?vue&type=style&index=0&id=3187a7c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3187a7c1",
  null
  
)

export default component.exports